import moment from "moment";
import Swal from "sweetalert2";

const formatDate = (dateString: moment.MomentInput, dateFormat = "MMMM DD, YYYY, HH:mm") => {
    if (!dateString) return "";
    return moment(dateString).format(dateFormat);
};

function formatDateInUS(isoDate: string): string {
  const date = new Date(isoDate);

  // options for formatting
  const options: Intl.DateTimeFormatOptions = {
    month: "short",   // Sep
    day: "2-digit",   // 06
    year: "numeric",  // 2025
    hour: "numeric",  // 3
    minute: "2-digit", // 57
    hour12: true,     // AM/PM
  };

  return date.toLocaleString("en-US", options);
}

function getPhoneCode(countryName:string) {
    const phoneCodes:any = {
      "united states": "+1",
      "canada": "+1",
      "india": "+91"
    };
  
    const normalized = countryName.trim().toLowerCase();
  
    return phoneCodes[normalized] || "+1";
  }

  /**
 * Sort an array of  objects by createdAt (descending)
 */
function sortByCreatedAtDesc(admissions: any[]): any[] {
  return [...admissions].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
}

/**
 * Shows a confirmation alert with a message.
 * Executes the callback if user confirms.
 */
function confirmAction(message: string, onConfirm: () => void): void {
  Swal.fire({
      title: "Are you sure?",
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
  }).then((result) => {
      if (result.isConfirmed) {
          onConfirm();
      }
  });
}

function generatePassword(length: number = 12): string {
  if (length < 9 || length > 50) {
    throw new Error("Password length must be between 9 and 50 characters");
  }

  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "&*%^$_#*";
  const allChars = upper + lower + numbers + special;

  const passwordArray: string[] = [];

  // ✅ Ensure each rule is satisfied
  passwordArray.push(getRandomChar(upper));
  passwordArray.push(getRandomChar(lower));
  passwordArray.push(getRandomChar(numbers));
  passwordArray.push(getRandomChar(special));

  // ✅ Fill remaining length
  for (let i = passwordArray.length; i < length; i++) {
    passwordArray.push(getRandomChar(allChars));
  }

  // ✅ Secure shuffle (Fisher-Yates)
  shuffleArray(passwordArray);

  return passwordArray.join("");
}

function getRandomChar(chars: string): string {
  const array = new Uint8Array(1);
  window.crypto.getRandomValues(array);
  return chars[array[0] % chars.length];
}

function shuffleArray(arr: string[]) {
  for (let i = arr.length - 1; i > 0; i--) {
    const rand = new Uint8Array(1);
    window.crypto.getRandomValues(rand);
    const j = rand[0] % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}



export { formatDate ,getPhoneCode,formatDateInUS,sortByCreatedAtDesc ,confirmAction,generatePassword};
